declare global {
  interface String {
    interpolate(params: any): string;
  }
}

String.prototype.interpolate = function (params: any) {
  return String(this).replace(/\$\{(\w+)\}/g, (_, key) =>
    Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : ''
  );
}

export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(' ')

  return value
    .normalize('NFD') // split an accented letter in the base letter and the accent
    .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-') // separator
}

export const sup = (value: string) =>
  value.replace(/(®|™|℠|©|℗)/ig, '<sup>$1</sup>')

export function formatAsterisk(title: string, tag?: string) {
  let newTitle = title.replace('*', `<${tag || 'i'}>`)
  newTitle = newTitle.replace('*', `</${tag || 'i'}>`)
  return newTitle
}

export const short = (value: string) => value
  // .replace(/\sapprox.*$/ig, '')
  // .replace(/foodservice,? /ig, '')
  // .replace(/food service,? /ig, '')
  // .replace(/signature cuts,? /ig, '')
  // .replace(/signature,? /ig, '')
  // .replace(/high liner foods,? /ig, '')
  // .replace(/high liner,? /ig, '')
  // .replace(/highliner,? /ig, '')
  // .trim()
  // .replace(/^(\-|\,)\s?/ig, '')
  // .replace(/(—).*$/ig, '')
  // .replace(/\//ig, '')
  // .replace(/\d.*?(lb| g| kg| oz| ct)\.?\s?/ig, '')
  // .trim()
  // .replace(/, ,/ig, '')
  // .replace(/,$/ig, '')
  // .replace(/\(\)/ig, '')
  .trim()
  // .toLowerCase()

export const kebabCase = (string:string) => string
  .replace(/([a-z])([A-Z])/g, "$1-$2")
  .replace(/[\s_]+/g, '-')
  .toLowerCase();